/**
 * Shared MapLibre layer identifiers for consistent layer ordering.
 * Used to ensure the vehicle (bus) custom layer stays above itinerary/route lines
 * and realtime transit path overlays, and below the user location marker and navigation layers.
 */
export const VEHICLE_CUSTOM_LAYER_ID = "vehicle-custom-layer";

/** GeoJSON source for the traversed route segment on realtime transit path selection. */
export const REALTIME_TRANSIT_PATH_TRAVERSED_SOURCE_ID = "realtime-transit-path-traversed-source";

/** Line layer for the traversed route segment on realtime transit path selection. */
export const REALTIME_TRANSIT_PATH_TRAVERSED_LAYER_ID = "realtime-transit-path-traversed-layer";

/** GeoJSON source for the current segment (vehicle position → next stop). */
export const REALTIME_TRANSIT_PATH_CURRENT_SOURCE_ID = "realtime-transit-path-current-source";

/** Line layer for the current segment (vehicle position → next stop). */
export const REALTIME_TRANSIT_PATH_CURRENT_LAYER_ID = "realtime-transit-path-current-layer";

/** GeoJSON source for the remaining route (next stop → terminus). */
export const REALTIME_TRANSIT_PATH_REMAINING_SOURCE_ID = "realtime-transit-path-remaining-source";

/** Line layer for the remaining route (next stop → terminus). */
export const REALTIME_TRANSIT_PATH_REMAINING_LAYER_ID = "realtime-transit-path-remaining-layer";

/** GeoJSON source id for parent station stops. */
export const STOPS_PARENTS_SOURCE_ID = "stops-parents";

/** GeoJSON source id for platform (child) stops. */
export const STOPS_CHILDREN_SOURCE_ID = "stops-children";

/** Symbol layer id for parent station icons and labels. */
export const STOPS_LAYER_PARENTS_ID = "stops-layer-parents";

/** Symbol layer id for platform stop pole icons. */
export const STOPS_LAYER_CHILDREN_ID = "stops-layer-children";

/** Symbol layer id for platform stop name labels. */
export const STOPS_LAYER_CHILDREN_NAME_ID = "stops-layer-children-name";

/** Symbol layer id for platform stop platform labels ("Quai X"). */
export const STOPS_LAYER_CHILDREN_PLATFORM_ID = "stops-layer-children-platform";

/** MapLibre sprite id for parent station pole icon. */
export const STOP_PARENT_ICON_IMAGE_ID = "stop-parent-icon";

/** MapLibre sprite id for platform stop pole icon. */
export const STOP_CHILD_ICON_IMAGE_ID = "stop-child-icon";

/** Layer ids that render stop name or platform text labels. */
export const STOP_LABEL_TEXT_LAYER_IDS = [
    STOPS_LAYER_PARENTS_ID,
    STOPS_LAYER_CHILDREN_NAME_ID,
    STOPS_LAYER_CHILDREN_PLATFORM_ID,
] as const;

/** Layer ids that handle stop click interactions. */
export const STOP_CLICK_LAYER_IDS = [
    STOPS_LAYER_PARENTS_ID,
    STOPS_LAYER_CHILDREN_ID,
] as const;

/** All custom stop symbol layers (excluded from base-style visibility toggles). */
export const STOP_CUSTOM_LAYER_IDS = [
    STOPS_LAYER_PARENTS_ID,
    STOPS_LAYER_CHILDREN_ID,
    STOPS_LAYER_CHILDREN_NAME_ID,
    STOPS_LAYER_CHILDREN_PLATFORM_ID,
] as const;

/** GeoJSON source id for bike stations. */
export const BIKE_STATIONS_SOURCE_ID = "bike-stations-source";

/** Circle layer id behind bike station icon. */
export const BIKE_STATIONS_BACKGROUND_LAYER_ID = "bike-stations-background-layer";

/** Symbol layer id for bike station icons and labels. */
export const BIKE_STATIONS_LAYER_ID = "bike-stations-layer";

/** MapLibre sprite id for bike station icon. */
export const BIKE_STATION_ICON_IMAGE_ID = "bike-station-icon";

/** MapLibre sprite id for bike station icon with a cross when no bikes are available. */
export const BIKE_STATION_EMPTY_ICON_IMAGE_ID = "bike-station-empty-icon";

/** All custom bike station layers (excluded from base-style visibility toggles). */
export const BIKE_CUSTOM_LAYER_IDS = [
    BIKE_STATIONS_BACKGROUND_LAYER_ID,
    BIKE_STATIONS_LAYER_ID,
] as const;
